export function nextImageIndex(index:number,delta:number,count:number):number { return count ? (index+delta+count)%count : 0 }
export function clampZoom(value:number):number { return Math.min(5,Math.max(1,value)) }
export function getLightboxKeyAction(key:string,index:number,count:number):{type:'close'}|{type:'change';index:number}|null {
  if(key==='Escape')return {type:'close'}
  if(key==='ArrowLeft')return {type:'change',index:nextImageIndex(index,-1,count)}
  if(key==='ArrowRight')return {type:'change',index:nextImageIndex(index,1,count)}
  return null
}
export function isBackdropClick(target:EventTarget|null,currentTarget:EventTarget|null):boolean {
  return target===currentTarget
}
export function getImageDownloadProps(url:string,name:string):{href:string;download:string} {
  return {href:url,download:name}
}
